import React, { useCallback, useEffect, useRef, useState } from 'react'
import google from "../../Assets/images/google.svg"
import apple from "../../Assets/images/apple-icon.svg"
import { decodeID, getBrowserType, saveToStorage } from '../../utils/Helper'
import {
  getCompleteProfileRedirect,
  getPostSocialLoginRedirect,
  markSocialProfileTransition,
  needsSocialProfileCompletion,
  saveSocialProfilePrefill,
  splitSocialDisplayName,
} from '../../utils/socialProfileCompletion'
import { LoginSocialApple } from 'reactjs-social-login';
import { Config } from '../../config/Config'

import { AppleLoginButton } from 'react-social-login-buttons';
import GoogleSocialLoginButton from './GoogleSocialLoginButton';
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import BrandedLoaderOverlay from './BrandedLoaderOverlay'
import { useLocation } from 'react-router-dom'
import { LanguageConstants } from '../../constants/LanguageConstants'

type SocialLoginProps = {
  /** Signup right column: Google left, Apple right (full width row, no “Or sign up with”) */
  signupGoogleAppleRow?: boolean;
  /** Login page: same row layout + “Or …” line hidden */
  loginGoogleAppleRow?: boolean;
};

function SocialLogin({ signupGoogleAppleRow = false, loginGoogleAppleRow = false }: SocialLoginProps) {
  const social_login = useMakeRequest()
  const REDIRECT_URI = Config?.REACT_BASE_URL;

  const google_client_id = decodeID(Config.GOOGLE_SOCIAL_LOGIN)
  const apple_client_id = decodeID(Config.APPLE_CLIENT_SECRET)
  const loaction  = useLocation()

  const [provider, setProvider] = useState('');
  const [profile, setProfile] = useState<any>({});
  const socialRequestSentRef = useRef(false);
  const [isNavigatingToCompleteProfile, setIsNavigatingToCompleteProfile] = useState(false);

  const buildSocialPayload = useCallback((resolvedProvider: string, data: any) => {
    if (!data || !resolvedProvider) return null;

    const social_type =
      resolvedProvider.toLowerCase().includes('apple') ? 'Apple' : 'Google';

    const social_id =
      data?.sub ||
      data?.id ||
      data?.user?.sub ||
      data?.authorization?.id_token;

    const email = data?.email || data?.user?.email;
    let name = data?.name;
    if (name && typeof name === 'object') {
      const first = name?.firstName || name?.givenName || '';
      const last = name?.lastName || name?.familyName || '';
      name = [first, last].filter(Boolean).join(' ');
    }
    if (!name && data?.user?.name) {
      name =
        typeof data.user.name === 'string'
          ? data.user.name
          : [data.user.name?.firstName, data.user.name?.lastName].filter(Boolean).join(' ');
    }

    if (!social_id || !email) return null;

    return {
      email,
      name: name || email,
      social_id: String(social_id),
      social_type,
    };
  }, []);

  const onLoginStart = useCallback(() => {
    socialRequestSentRef.current = false;
  }, []);

  const onLogoutFailure = useCallback(() => {
    // alert("logout fail");
  }, []);

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider("");
    alert("logout success");
  }, []);

  const handleGoogleSuccess = useCallback(
    (data: { sub: string; email: string; name: string; access_token: string }) => {
      socialRequestSentRef.current = false;
      setProvider('google');
      setProfile(data);
    },
    [],
  );

  const handleGoogleError = useCallback((err?: unknown) => {
    console.error('Google login error:', err);
  }, []);

  useEffect(() => {
    const payload = buildSocialPayload(provider, profile);
    if (!payload || socialRequestSentRef.current) return;
    const googleReady =
      Boolean(profile?.access_token) || (Boolean(profile?.sub) && Boolean(profile?.email));
    if (provider.toLowerCase().includes('google') && !googleReady) return;

    socialRequestSentRef.current = true;
    social_login.makeRequest({ payload, url: ApiConstants?.Social_login, toastStatus: true });
  }, [provider, profile, buildSocialPayload]);

  useEffect(() => {
    if (!social_login?.status) return;

    const accessToken = social_login?.data?.access_token;
    const user = social_login?.data?.data;
    saveToStorage({ key: 'access_token', value: accessToken });
    saveToStorage({ key: 'user_data', value: social_login?.data });

    const split = splitSocialDisplayName(user?.name || profile?.name || '');
    saveSocialProfilePrefill({
      email: user?.email || profile?.email,
      first_name: user?.first_name || split.first_name,
      last_name: user?.last_name || split.last_name,
      name: user?.name || profile?.name,
      social_type: user?.social_type || (provider.toLowerCase().includes('apple') ? 'Apple' : 'Google'),
    });

    if (!user || needsSocialProfileCompletion(user)) {
      markSocialProfileTransition();
      setIsNavigatingToCompleteProfile(true);
      window.location.href = getCompleteProfileRedirect();
      return;
    }
    window.location.href = getPostSocialLoginRedirect(user);
  }, [social_login.status, profile, provider]);

  const showSocialLoader = social_login.loading || isNavigatingToCompleteProfile;

  const showGoogle = true
  /** Apple button: Mac par hi (pehle wali condition) */
  const showApple = getBrowserType(navigator.userAgent)?.platform === 'Mac'

  return (
    <>
    <BrandedLoaderOverlay active={showSocialLoader} immediate />
      <div
        className={`or-login-area${
          signupGoogleAppleRow || loginGoogleAppleRow ? ' or-login-area--signup-google-apple-row' : ''
        }`}
      >
        {!signupGoogleAppleRow && !loginGoogleAppleRow ? (
          <div className="or-line">
            <span className="txt">{loaction?.pathname === '/login'  ? LanguageConstants?.LOGIN_WITH : LanguageConstants?.SINGUP_WITH }</span>
          </div>
        ) : null}
        <ul className="social-footer">
          {/* <li>
            <div><img src={microsoft} alt="facebook icon" /></div>
            <LoginSocialMicrosoft
          client_id={process.env.REACT_APP_MICROSOFT_APP_ID || ''}
          redirect_uri={REDIRECT_URI}
          onLoginStart={onLoginStart}
          onResolve={({ provider, data }: IResolveParams) => {
            setProvider(provider);
            setProfile(data);
          }}
          onReject={(err: any) => {
          }}
        >
          <MicrosoftLoginButton />
        </LoginSocialMicrosoft>
          </li> */}
          {showGoogle && google_client_id ? (
          <li className="social-footer-item">
            <div><img src={google} alt="" /></div>
            <GoogleSocialLoginButton
              clientId={google_client_id}
              buttonText={
                signupGoogleAppleRow || loginGoogleAppleRow ? 'Continue with Google' : undefined
              }
              onLoginStart={onLoginStart}
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
            />
          </li>
          ) : null}
          {showApple ? (
          <li className="social-footer-item">
            <div><img src={apple} alt="" /></div>
            <LoginSocialApple
              client_id={apple_client_id}
              redirect_uri={REDIRECT_URI}
              onLoginStart={onLoginStart}
              onResolve={({ provider, data }) => {
                socialRequestSentRef.current = false;
                setProvider(provider);
                setProfile(data);
              }}
              onReject={(err) => {
                console.error('Apple login error:', err);
              }}

            >
              <AppleLoginButton text="Continue with Apple" />
            </LoginSocialApple>
          </li>
          ) : null}
          </ul>
      </div>
    </>
  )
}

export default SocialLogin